import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { PlatformUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type PlatformUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  name: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  nameError?: string;
  platformUpdateStore: PlatformUpdateStore;
};

export const PlatformUpdateForm: React.FC<PlatformUpdateFormProps> = observer(
  ({
    onSave = () => {},
    onCancel = () => {},
    saving = false,
    showToolbox = true,
    showSaveFooter,
    name = "",
    nameError,
    onNameChange = () => {},
    platformUpdateStore,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            saveAndCloseLabel={langStore.saveEntity}
            closeLabel={langStore.cancelUpdatedEntity}
            saveForm={() => onSave()}
            saveDisabled={saving}
            closeForm={() => onCancel()}
          />
        )}
        <Box>
          <FormExtras
            entity="Platform"
            mode="update"
            values={{}}
            options={{}}
            onPatch={(campo: string, valor: any) => {
              switch (campo) {
                case "name":
                  onNameChange?.(valor);
                  break;
              }
            }}
          />
          <GroupContainer
            id="null"
            errorText={platformUpdateStore.getCardErrors("null")}
            title={langStore.groupPlatformLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <InputString
                autoFocus
                value={name}
                error={Boolean(nameError)}
                warning={
                  !nameError && Boolean(platformUpdateStore.warnings["name"])
                }
                helperText={
                  nameError || platformUpdateStore.warnings["name"]?.message
                }
                label={langStore.PlatformNameLabel}
                onChange={(value: string) => onNameChange(value)}
                description={langStore.PlatformNameDescription}
              />
            </FormControl>
          </GroupContainer>
        </Box>
        {(showSaveFooter ?? !showToolbox) && (
          <FormSaveFooter
            onSave={() => onSave()}
            label={langStore.saveEntity}
            disabled={saving}
          />
        )}
      </Grid>
    );
  }
);
